export const TOOLBAR_RANK = {
	AI: 100,
};

export const AI_SECTION_RANK = {
	ROVO: 100,
	IMPROVE_WRITING: 200,
};

export const ROVO_GROUP_RANK = {
	ROVO_BUTTON: 100,
	ROVO_MENU: 200,
};

export const IMPROVE_WRITING_GROUP_RANK = {
	IMPROVE_WRITING: 100,
};

export const ROVO_MENU_RANK = {
	OPTIONS: 100,
};

export const ROVO_MENU_SECTION_RANK = {
	MAKE_SHORTER: 100,
	MAKE_LONGER: 200,
	CHANGE_TONE: 300,
	SPELLING_AND_GRAMMAR: 400,
	TRANSLATE: 500,
	SUMMARIZE: 600,
};

export const ROVO_CHANGE_TONE_MENU_RANK = {
	OPTIONS: 100,
};

export const ROVO_CHANGE_TONE_MENU_SECTION_RANK = {
	MORE_PROFESSIONAL: 100,
	MORE_CASUAL: 200,
	MORE_EMPATHETIC: 300,
};

export const ROVO_TRANSLATE_MENU_RANK = {
	OPTIONS: 100,
};

export const TEXT_SECTION_RANK = {
	STYLES: 100,
	FORMAT: 200,
};

export const TEXT_FORMAT_GROUP_RANK = {
	FORMAT_BUTTON: 100,
	MORE_FORMATTING: 200,
};

export const TEXT_FORMAT_MENU_SECTION_RANK = {
	FORMAT_OPTIONS: 100,
	CLEAR_FORMAT: 200,
};

export const TEXT_FORMAT_OPTION_MENU_RANK = {
	BOLD: 100,
	ITALIC: 200,
	UNDERLINE: 300,
	STRIKETHROUGH: 400,
	CODE: 500,
	SUBSCRIPT: 600,
	SUPERSCRIPT: 700,
};

export const TEXT_FORMAT_CLEAR_MENU_RANK = {
	CLEAR_FORMAT: 100,
};
